import * as actionTypes from "../../../constants/ActionTypes/AdminPortal/FeatureSwitch";

const initialState = {
    data: {},
    loading: false,
    success: false,
    error: null
}

const UpdateFeatureSwitch = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_FEATURE_SWITCH_INIT:
            return {
                ...state,
                loading: true,
                success: false
            }
        
        case actionTypes.UPDATE_FEATURE_SWITCH_SUCCESS:
            return {
                ...state,
                data: action.data,
                loading: false,
                error: null,
                success: true
            }
        
        case actionTypes.UPDATE_FEATURE_SWITCH_ERROR:
            return {
                ...state,
                loading: false,
                error: action.message,
                success: false,
                data: {}
            }
        case actionTypes.UPDATE_FEATURE_SWITCH_RESET_STATE:
            return {
                data: {},
                loading: false,
                success: false,
                error: null
            }
        default:
            return {...state}
    }
}

export default UpdateFeatureSwitch